import { DELETE_REQUESTED } from '../../../../services/core/reducerFactory/types';

export default {
  SHOW_DETAIL_VIEW: 'SHOW_DETAIL_VIEW',
  DELETE_REQUESTED: DELETE_REQUESTED.replace('*', 'csServices')
};
